import type { SelectableTableProps } from '@openx/types/selectableTable';
import type { BaseRow } from '@openx/types/tableHelpers';
import { type ComponentType, type JSX, useMemo } from 'react';

import type { TableProps } from '../Table';

import { extendColumnsWithCheckbox } from './extendColumnsWithCheckbox';

export function SelectableTable<
  RowT extends BaseRow,
  FiltersT extends Record<string, unknown> = Record<string, unknown>,
  TablePropsT extends TableProps<RowT, FiltersT> = TableProps<RowT, FiltersT>,
>(WrappedTable: ComponentType<TablePropsT>): (props: TablePropsT & SelectableTableProps<RowT>) => JSX.Element {
  // biome-ignore lint/correctness/noNestedComponentDefinitions: HOC
  function WrappingTable(props: TablePropsT & SelectableTableProps<RowT>): JSX.Element {
    const { columns, data, loading, selectedItems, disabledItems, toggleSelect, onToggleAll } = props;

    const extendedColumns = useMemo(
      () =>
        extendColumnsWithCheckbox(columns, data, { selectedItems, disabledItems, toggleSelect, onToggleAll }, loading),
      [columns, data, selectedItems, disabledItems, toggleSelect, loading, onToggleAll]
    );

    return <WrappedTable {...props} columns={extendedColumns} />;
  }

  return WrappingTable;
}
